import request, { ResponseData } from "logic/src/utils/request";
import { PATH_PREFIX } from "logic/src/constants/request";
import i18next from "logic/src/i18n";
import { META_DATA } from "../constants";

const PREFIX = `${PATH_PREFIX}/global/v1.0.0`;

let systemType = META_DATA.projectName === "mbs" ? "h5" : "web";
const version_code = localStorage.getItem("version_code");
const system_type = localStorage.getItem("system_type");
// App 内打开h5
if (!!version_code && !!system_type) {
  systemType = system_type.toLowerCase();
}

const commonHeaders = {
  "system-type": systemType,
  "version-code":
    META_DATA.projectName === "mbs" && version_code ? version_code : "",
};

const commonParams = {
  area: i18next.language,
};

// 解析ip
export async function getUserIp(): Promise<ResponseData> {
  return request.get(`${PREFIX}/customeip`, {
    ...commonParams,
  });
}

// 全局组件开关(实名认证/邀请码)
export async function getGlobalConf() {
  return await request.get(
    `${PREFIX}/config`,
    {
      ...commonParams,
    },
    {
      headers: commonHeaders,
    },
  );
}
